import React from "react";
import { useTranslations } from "next-intl";
import styled from "styled-components";

import iconBar from "assets/icons/android_icon_bar.png";
import moreIcon from "assets/icons/android_more_icon.png";

import { Layout, ListItemText, PageTitle, StickyButton } from "@src/packages/chime-ui";
import { EditSettings } from "@src/components";

const Strong = styled.span`
  font-weight: 600 !important;
`;

const IconWrapper = styled.img`
  box-shadow:
    0 8px 12px 0 rgba(0, 0, 0, 0.16),
    0 24px 32px 0 rgba(0, 0, 0, 0.04);
  margin: 0 auto;
`;

const InlineIconWrapper = styled.div`
  display: flex;
  align-items: center;
`;

const Center = styled.div`
  text-align: center;
`;

const strong = { strong: (c: React.ReactNode) => <Strong>{c}</Strong> };

interface Props {
  onComplete: () => void;
}

export const EnableCameraAccessAndroid = ({ onComplete }: Props) => {
  const t = useTranslations("permissions.android");

  return (
    <Layout>
      <EditSettings />
      <PageTitle role="heading">{t("title")}</PageTitle>

      <InlineIconWrapper>
        <ListItemText>{t("step1")}</ListItemText>
        <IconWrapper src={moreIcon.src} alt="Android More Bar" height="40" />
      </InlineIconWrapper>

      <ListItemText>{t("step2")}</ListItemText>

      <Center>
        <IconWrapper src={iconBar.src} alt="Android Icon Bar" height="40" />
      </Center>

      <ListItemText>{t.rich("step3", strong)}</ListItemText>
      <ListItemText>{t.rich("step4", strong)}</ListItemText>

      <StickyButton name="tryAgain" onClick={onComplete}>
        Try Again
      </StickyButton>
    </Layout>
  );
};
